import { Pipe, PipeTransform } from '@angular/core';

export interface KpDurationArgs {
  secLabel?: string;
  minLabel?: string;
  hourLabel?: string;
  /** Keep the seconds below the hour ("1 min 20 s") instead of flooring to whole minutes ("1 min"). */
  precise?: boolean;
}

const DEFAULT_ARGS: KpDurationArgs = { secLabel: 's', minLabel: 'min', hourLabel: 'h', precise: false };

@Pipe({
  name: 'kpDuration',
  standalone: true,
})
export class KpDurationPipe implements PipeTransform {
  transform(value: any, args: KpDurationArgs = DEFAULT_ARGS): string {
    if (!value) {
      return '--:--';
    }
    const { secLabel, minLabel, hourLabel, precise } = { ...DEFAULT_ARGS, ...args };

    const seconds = Math.floor(+value);

    if (seconds < 60) {
      return `${seconds} ${secLabel}`;
    }

    const minutes = this.toMinutes(seconds);
    if (seconds < 3600) {
      const remainingSeconds = seconds % 60;
      return precise && remainingSeconds
        ? `${minutes} ${minLabel} ${remainingSeconds} ${secLabel}`
        : `${minutes} ${minLabel}`;
    }

    const hours = Math.floor(seconds / 3600);
    return hours + ` ${hourLabel} ` + minutes + ` ${minLabel}`;
  }

  private toMinutes(seconds: number) {
    return Math.floor(((seconds % 3600) / 3600) * 60);
  }
}
